export const province = [{
  value: 110000,
  text: '北京市',
  parentId: 0
}, {
  value: 120000,
  text: '天津市',
  parentId: 0
}, {
  value: 130000,
  text: '河北省',
  parentId: 0
}, {
  value: 140000,
  text: '山西省',
  parentId: 0
}, {
  value: 150000,
  text: '内蒙古自治区',
  parentId: 0
}, {
  value: 210000,
  text: '辽宁省',
  parentId: 0
}, {
  value: 220000,
  text: '吉林省',
  parentId: 0
}, {
  value: 230000,
  text: '黑龙江省',
  parentId: 0
}, {
  value: 310000,
  text: '上海市',
  parentId: 0
}, {
  value: 320000,
  text: '江苏省',
  parentId: 0
}, {
  value: 330000,
  text: '浙江省',
  parentId: 0
}, {
  value: 340000,
  text: '安徽省',
  parentId: 0
}, {
  value: 350000,
  text: '福建省',
  parentId: 0
}, {
  value: 360000,
  text: '江西省',
  parentId: 0
}, {
  value: 370000,
  text: '山东省',
  parentId: 0
}, {
  value: 410000,
  text: '河南省',
  parentId: 0
}, {
  value: 420000,
  text: '湖北省',
  parentId: 0
}, {
  value: 430000,
  text: '湖南省',
  parentId: 0
}, {
  value: 440000,
  text: '广东省',
  parentId: 0
}, {
  value: 450000,
  text: '广西壮族自治区',
  parentId: 0
}, {
  value: 460000,
  text: '海南省',
  parentId: 0
}, {
  value: 500000,
  text: '重庆市',
  parentId: 0
}, {
  value: 510000,
  text: '四川省',
  parentId: 0
}, {
  value: 520000,
  text: '贵州省',
  parentId: 0
}, {
  value: 530000,
  text: '云南省',
  parentId: 0
}, {
  value: 540000,
  text: '西藏自治区',
  parentId: 0
}, {
  value: 610000,
  text: '陕西省',
  parentId: 0
}, {
  value: 620000,
  text: '甘肃省',
  parentId: 0
}, {
  value: 630000,
  text: '青海省',
  parentId: 0
}, {
  value: 640000,
  text: '宁夏回族自治区',
  parentId: 0
}, {
  value: 650000,
  text: '新疆维吾尔自治区',
  parentId: 0
}, {
  value: 710000,
  text: '台湾省',
  parentId: 0
}, {
  value: 810000,
  text: '香港特别行政区',
  parentId: 0
}, {
  value: 820000,
  text: '澳门特别行政区',
  parentId: 0
}];


export const city = [{
  value: 110100,
  text: '东城区',
  parentId: 110000
}, {
  value: 110200,
  text: '西城区',
  parentId: 110000
},{
  value: 110300,
  text: '朝阳区',
  parentId: 110000
},{
  value: 110400,
  text: '丰台区',
  parentId: 110000
},{
  value: 110500,
  text: '石景山区',
  parentId: 110000
},{
  value: 110600,
  text: '海定区',
  parentId: 110000
},{
  value: 110700,
  text: '门头沟区',
  parentId: 110000
},{
  value: 110800,
  text: '房山区',
  parentId: 110000
},{
  value: 110900,
  text: '通州区',
  parentId: 110000
},{
  value: 111000,
  text: '顺义区',
  parentId: 110000
},{
  value: 111100,
  text: '昌平区',
  parentId: 110000
},{
  value: 111200,
  text: '大兴区',
  parentId: 110000
},{
  value: 111300,
  text: '怀柔区',
  parentId: 110000
},{
  value: 111400,
  text: '平谷区',
  parentId: 110000
},{
  value: 111500,
  text: '密云区',
  parentId: 110000
},{
  value: 111600,
  text: '延庆区',
  parentId: 110000
}, {
  value: 120100,
  text: '和平区',
  parentId: 120000
}, {
  value: 120200,
  text: '河东区',
  parentId: 120000
},  {
  value: 120300,
  text: '河西区',
  parentId: 120000
},  {
  value: 120400,
  text: '南开区',
  parentId: 120000
},  {
  value: 120500,
  text: '河北区',
  parentId: 120000
},  {
  value: 120600,
  text: '红桥区',
  parentId: 120000
},  {
  value: 120700,
  text: '东丽区',
  parentId: 120000
},  {
  value: 120800,
  text: '西青区',
  parentId: 120000
},  {
  value: 120900,
  text: '津南区',
  parentId: 120000
},  {
  value: 121000,
  text: '北辰区',
  parentId: 120000
},  {
  value: 121100,
  text: '武清区',
  parentId: 120000
},  {
  value: 121200,
  text: '宝坻区',
  parentId: 120000
},  {
  value: 121300,
  text: '滨海新区',
  parentId: 120000
},  {
  value: 121400,
  text: '宁河区',
  parentId: 120000
},  {
  value: 121500,
  text: '静海区',
  parentId: 120000
},  {
  value: 121600,
  text: '蓟县',
  parentId: 120000
},  {
  value: 130100,
  text: '石家庄市',
  parentId: 130000
}, {
  value: 130200,
  text: '唐山市',
  parentId: 130000
}, {
  value: 130300,
  text: '秦皇岛市',
  parentId: 130000
}, {
  value: 130400,
  text: '邯郸市',
  parentId: 130000
}, {
  value: 130500,
  text: '邢台市',
  parentId: 130000
}, {
  value: 130600,
  text: '保定市',
  parentId: 130000
}, {
  value: 130700,
  text: '张家口市',
  parentId: 130000
}, {
  value: 130800,
  text: '承德市',
  parentId: 130000
}, {
  value: 130900,
  text: '沧州市',
  parentId: 130000
}, {
  value: 131000,
  text: '廊坊市',
  parentId: 130000
}, {
  value: 131100,
  text: '衡水市',
  parentId: 130000
}, {
  value: 140100,
  text: '太原市',
  parentId: 140000
}, {
  value: 140200,
  text: '大同市',
  parentId: 140000
}, {
  value: 140300,
  text: '阳泉市',
  parentId: 140000
}, {
  value: 140400,
  text: '长治市',
  parentId: 140000
}, {
  value: 140500,
  text: '晋城市',
  parentId: 140000
}, {
  value: 140600,
  text: '朔州市',
  parentId: 140000
}, {
  value: 140700,
  text: '晋中市',
  parentId: 140000
}, {
  value: 140800,
  text: '运城市',
  parentId: 140000
}, {
  value: 140900,
  text: '忻州市',
  parentId: 140000
}, {
  value: 141000,
  text: '临汾市',
  parentId: 140000
}, {
  value: 141100,
  text: '吕梁市',
  parentId: 140000
}, {
  value: 150100,
  text: '呼和浩特市',
  parentId: 150000
}, {
  value: 150200,
  text: '包头市',
  parentId: 150000
}, {
  value: 150300,
  text: '乌海市',
  parentId: 150000
}, {
  value: 150400,
  text: '赤峰市',
  parentId: 150000
}, {
  value: 150500,
  text: '通辽市',
  parentId: 150000
}, {
  value: 150600,
  text: '鄂尔多斯市',
  parentId: 150000
}, {
  value: 150700,
  text: '呼伦贝尔市',
  parentId: 150000
}, {
  value: 150800,
  text: '巴彦淖尔市',
  parentId: 150000
}, {
  value: 150900,
  text: '乌兰察布市',
  parentId: 150000
}, {
  value: 152200,
  text: '兴安盟',
  parentId: 150000
}, {
  value: 152500,
  text: '锡林郭勒盟',
  parentId: 150000
}, {
  value: 152900,
  text: '阿拉善盟',
  parentId: 150000
}, {
  value: 210100,
  text: '沈阳市',
  parentId: 210000
}, {
  value: 210200,
  text: '大连市',
  parentId: 210000
}, {
  value: 210300,
  text: '鞍山市',
  parentId: 210000
}, {
  value: 210400,
  text: '抚顺市',
  parentId: 210000
}, {
  value: 210500,
  text: '本溪市',
  parentId: 210000
}, {
  value: 210600,
  text: '丹东市',
  parentId: 210000
}, {
  value: 210700,
  text: '锦州市',
  parentId: 210000
}, {
  value: 210800,
  text: '营口市',
  parentId: 210000
}, {
  value: 210900,
  text: '阜新市',
  parentId: 210000
}, {
  value: 211000,
  text: '辽阳市',
  parentId: 210000
}, {
  value: 211100,
  text: '盘锦市',
  parentId: 210000
}, {
  value: 211200,
  text: '铁岭市',
  parentId: 210000
}, {
  value: 211300,
  text: '朝阳市',
  parentId: 210000
}, {
  value: 211400,
  text: '葫芦岛市',
  parentId: 210000
}, {
  value: 220100,
  text: '长春市',
  parentId: 220000
}, {
  value: 220200,
  text: '吉林市',
  parentId: 220000
}, {
  value: 220300,
  text: '四平市',
  parentId: 220000
}, {
  value: 220400,
  text: '辽源市',
  parentId: 220000
}, {
  value: 220500,
  text: '通化市',
  parentId: 220000
}, {
  value: 220600,
  text: '白山市',
  parentId: 220000
}, {
  value: 220700,
  text: '松原市',
  parentId: 220000
}, {
  value: 220800,
  text: '白城市',
  parentId: 220000
}, {
  value: 222400,
  text: '延边朝鲜族自治州',
  parentId: 220000
}, {
  value: 230100,
  text: '哈尔滨市',
  parentId: 230000
}, {
  value: 230200,
  text: '齐齐哈尔市',
  parentId: 230000
}, {
  value: 230300,
  text: '鸡西市',
  parentId: 230000
}, {
  value: 230400,
  text: '鹤岗市',
  parentId: 230000
}, {
  value: 230500,
  text: '双鸭山市',
  parentId: 230000
}, {
  value: 230600,
  text: '大庆市',
  parentId: 230000
}, {
  value: 230700,
  text: '伊春市',
  parentId: 230000
}, {
  value: 230800,
  text: '佳木斯市',
  parentId: 230000
}, {
  value: 230900,
  text: '七台河市',
  parentId: 230000
}, {
  value: 231000,
  text: '牡丹江市',
  parentId: 230000
}, {
  value: 231100,
  text: '黑河市',
  parentId: 230000
}, {
  value: 231200,
  text: '绥化市',
  parentId: 230000
}, {
  value: 232700,
  text: '大兴安岭地区',
  parentId: 230000
}, {
  value: 310100,
  text: '黄浦区',
  parentId: 310000
}, {
  value: 310200,
  text: '徐汇区',
  parentId: 310000
}, {
  value: 310300,
  text: '长宁区',
  parentId: 310000
}, {
  value: 310400,
  text: '静安区',
  parentId: 310000
}, {
  value: 310500,
  text: '普陀区',
  parentId: 310000
}, {
  value: 310600,
  text: '虹口区',
  parentId: 310000
}, {
  value: 310700,
  text: '杨浦区',
  parentId: 310000
}, {
  value: 310800,
  text: '闵行区',
  parentId: 310000
}, {
  value: 310900,
  text: '宝山区',
  parentId: 310000
}, {
  value: 311000,
  text: '嘉定区',
  parentId: 310000
}, {
  value: 311100,
  text: '浦东新区',
  parentId: 310000
}, {
  value: 311200,
  text: '金山区',
  parentId: 310000
}, {
  value: 311300,
  text: '松江区',
  parentId: 310000
}, {
  value: 311400,
  text: '青浦区',
  parentId: 310000
}, {
  value: 311500,
  text: '秦贤区',
  parentId: 310000
}, {
  value: 311600,
  text: '崇明县',
  parentId: 310000
}, {
  value: 320100,
  text: '南京市',
  parentId: 320000
}, {
  value: 320200,
  text: '无锡市',
  parentId: 320000
}, {
  value: 320300,
  text: '徐州市',
  parentId: 320000
}, {
  value: 320400,
  text: '常州市',
  parentId: 320000
}, {
  value: 320500,
  text: '苏州市',
  parentId: 320000
}, {
  value: 320600,
  text: '南通市',
  parentId: 320000
}, {
  value: 320700,
  text: '连云港市',
  parentId: 320000
}, {
  value: 320800,
  text: '淮安市',
  parentId: 320000
}, {
  value: 320900,
  text: '盐城市',
  parentId: 320000
}, {
  value: 321000,
  text: '扬州市',
  parentId: 320000
}, {
  value: 321100,
  text: '镇江市',
  parentId: 320000
}, {
  value: 321200,
  text: '泰州市',
  parentId: 320000
}, {
  value: 321300,
  text: '宿迁市',
  parentId: 320000
}, {
  value: 330100,
  text: '杭州市',
  parentId: 330000
}, {
  value: 330200,
  text: '宁波市',
  parentId: 330000
}, {
  value: 330300,
  text: '温州市',
  parentId: 330000
}, {
  value: 330400,
  text: '嘉兴市',
  parentId: 330000
}, {
  value: 330500,
  text: '湖州市',
  parentId: 330000
}, {
  value: 330600,
  text: '绍兴市',
  parentId: 330000
}, {
  value: 330700,
  text: '金华市',
  parentId: 330000
}, {
  value: 330800,
  text: '衢州市',
  parentId: 330000
}, {
  value: 330900,
  text: '舟山市',
  parentId: 330000
}, {
  value: 331000,
  text: '台州市',
  parentId: 330000
}, {
  value: 331100,
  text: '丽水市',
  parentId: 330000
}, {
  value: 340100,
  text: '合肥市',
  parentId: 340000
}, {
  value: 340200,
  text: '芜湖市',
  parentId: 340000
}, {
  value: 340300,
  text: '蚌埠市',
  parentId: 340000
}, {
  value: 340400,
  text: '淮南市',
  parentId: 340000
}, {
  value: 340500,
  text: '马鞍山市',
  parentId: 340000
}, {
  value: 340600,
  text: '淮北市',
  parentId: 340000
}, {
  value: 340700,
  text: '铜陵市',
  parentId: 340000
}, {
  value: 340800,
  text: '安庆市',
  parentId: 340000
}, {
  value: 341000,
  text: '黄山市',
  parentId: 340000
}, {
  value: 341100,
  text: '滁州市',
  parentId: 340000
}, {
  value: 341200,
  text: '阜阳市',
  parentId: 340000
}, {
  value: 341300,
  text: '宿州市',
  parentId: 340000
}, {
  value: 341500,
  text: '六安市',
  parentId: 340000
}, {
  value: 341600,
  text: '亳州市',
  parentId: 340000
}, {
  value: 341700,
  text: '池州市',
  parentId: 340000
}, {
  value: 341800,
  text: '宣城市',
  parentId: 340000
}, {
  value: 350100,
  text: '福州市',
  parentId: 350000
}, {
  value: 350200,
  text: '厦门市',
  parentId: 350000
}, {
  value: 350300,
  text: '莆田市',
  parentId: 350000
}, {
  value: 350400,
  text: '三明市',
  parentId: 350000
}, {
  value: 350500,
  text: '泉州市',
  parentId: 350000
}, {
  value: 350600,
  text: '漳州市',
  parentId: 350000
}, {
  value: 350700,
  text: '南平市',
  parentId: 350000
}, {
  value: 350800,
  text: '龙岩市',
  parentId: 350000
}, {
  value: 350900,
  text: '宁德市',
  parentId: 350000
}, {
  value: 360100,
  text: '南昌市',
  parentId: 360000
}, {
  value: 360200,
  text: '景德镇市',
  parentId: 360000
}, {
  value: 360300,
  text: '萍乡市',
  parentId: 360000
}, {
  value: 360400,
  text: '九江市',
  parentId: 360000
}, {
  value: 360500,
  text: '新余市',
  parentId: 360000
}, {
  value: 360600,
  text: '鹰潭市',
  parentId: 360000
}, {
  value: 360700,
  text: '赣州市',
  parentId: 360000
}, {
  value: 360800,
  text: '吉安市',
  parentId: 360000
}, {
  value: 360900,
  text: '宜春市',
  parentId: 360000
}, {
  value: 361000,
  text: '抚州市',
  parentId: 360000
}, {
  value: 361100,
  text: '上饶市',
  parentId: 360000
}, {
  value: 370100,
  text: '济南市',
  parentId: 370000
}, {
  value: 370200,
  text: '青岛市',
  parentId: 370000
}, {
  value: 370300,
  text: '淄博市',
  parentId: 370000
}, {
  value: 370400,
  text: '枣庄市',
  parentId: 370000
}, {
  value: 370500,
  text: '东营市',
  parentId: 370000
}, {
  value: 370600,
  text: '烟台市',
  parentId: 370000
}, {
  value: 370700,
  text: '潍坊市',
  parentId: 370000
}, {
  value: 370800,
  text: '济宁市',
  parentId: 370000
}, {
  value: 370900,
  text: '泰安市',
  parentId: 370000
}, {
  value: 371000,
  text: '威海市',
  parentId: 370000
}, {
  value: 371100,
  text: '日照市',
  parentId: 370000
}, {
  value: 371200,
  text: '莱芜市',
  parentId: 370000
}, {
  value: 371300,
  text: '临沂市',
  parentId: 370000
}, {
  value: 371400,
  text: '德州市',
  parentId: 370000
}, {
  value: 371500,
  text: '聊城市',
  parentId: 370000
}, {
  value: 371600,
  text: '滨州市',
  parentId: 370000
}, {
  value: 371700,
  text: '菏泽市',
  parentId: 370000
}, {
  value: 410100,
  text: '郑州市',
  parentId: 410000
}, {
  value: 410200,
  text: '开封市',
  parentId: 410000
}, {
  value: 410300,
  text: '洛阳市',
  parentId: 410000
}, {
  value: 410400,
  text: '平顶山市',
  parentId: 410000
}, {
  value: 410500,
  text: '安阳市',
  parentId: 410000
}, {
  value: 410600,
  text: '鹤壁市',
  parentId: 410000
}, {
  value: 410700,
  text: '新乡市',
  parentId: 410000
}, {
  value: 410800,
  text: '焦作市',
  parentId: 410000
}, {
  value: 410900,
  text: '濮阳市',
  parentId: 410000
}, {
  value: 411000,
  text: '许昌市',
  parentId: 410000
}, {
  value: 411100,
  text: '漯河市',
  parentId: 410000
}, {
  value: 411200,
  text: '三门峡市',
  parentId: 410000
}, {
  value: 411300,
  text: '南阳市',
  parentId: 410000
}, {
  value: 411400,
  text: '商丘市',
  parentId: 410000
}, {
  value: 411500,
  text: '信阳市',
  parentId: 410000
}, {
  value: 411600,
  text: '周口市',
  parentId: 410000
}, {
  value: 411700,
  text: '驻马店市',
  parentId: 410000
}, {
  value: 419000,
  text: '省直辖县级行政区划',
  parentId: 410000
}, {
  value: 420100,
  text: '武汉市',
  parentId: 420000
}, {
  value: 420200,
  text: '黄石市',
  parentId: 420000
}, {
  value: 420300,
  text: '十堰市',
  parentId: 420000
}, {
  value: 420500,
  text: '宜昌市',
  parentId: 420000
}, {
  value: 420600,
  text: '襄阳市',
  parentId: 420000
}, {
  value: 420700,
  text: '鄂州市',
  parentId: 420000
}, {
  value: 420800,
  text: '荆门市',
  parentId: 420000
}, {
  value: 420900,
  text: '孝感市',
  parentId: 420000
}, {
  value: 421000,
  text: '荆州市',
  parentId: 420000
}, {
  value: 421100,
  text: '黄冈市',
  parentId: 420000
}, {
  value: 421200,
  text: '咸宁市',
  parentId: 420000
}, {
  value: 421300,
  text: '随州市',
  parentId: 420000
}, {
  value: 422800,
  text: '恩施土家族苗族自治州',
  parentId: 420000
}, {
  value: 429000,
  text: '省直辖县级行政区划',
  parentId: 420000
}, {
  value: 430100,
  text: '长沙市',
  parentId: 430000
}, {
  value: 430200,
  text: '株洲市',
  parentId: 430000
}, {
  value: 430300,
  text: '湘潭市',
  parentId: 430000
}, {
  value: 430400,
  text: '衡阳市',
  parentId: 430000
}, {
  value: 430500,
  text: '邵阳市',
  parentId: 430000
}, {
  value: 430600,
  text: '岳阳市',
  parentId: 430000
}, {
  value: 430700,
  text: '常德市',
  parentId: 430000
}, {
  value: 430800,
  text: '张家界市',
  parentId: 430000
}, {
  value: 430900,
  text: '益阳市',
  parentId: 430000
}, {
  value: 431000,
  text: '郴州市',
  parentId: 430000
}, {
  value: 431100,
  text: '永州市',
  parentId: 430000
}, {
  value: 431200,
  text: '怀化市',
  parentId: 430000
}, {
  value: 431300,
  text: '娄底市',
  parentId: 430000
}, {
  value: 433100,
  text: '湘西土家族苗族自治州',
  parentId: 430000
}, {
  value: 440100,
  text: '广州市',
  parentId: 440000
}, {
  value: 440200,
  text: '韶关市',
  parentId: 440000
}, {
  value: 440300,
  text: '深圳市',
  parentId: 440000
}, {
  value: 440400,
  text: '珠海市',
  parentId: 440000
}, {
  value: 440500,
  text: '汕头市',
  parentId: 440000
}, {
  value: 440600,
  text: '佛山市',
  parentId: 440000
}, {
  value: 440700,
  text: '江门市',
  parentId: 440000
}, {
  value: 440800,
  text: '湛江市',
  parentId: 440000
}, {
  value: 440900,
  text: '茂名市',
  parentId: 440000
}, {
  value: 441200,
  text: '肇庆市',
  parentId: 440000
}, {
  value: 441300,
  text: '惠州市',
  parentId: 440000
}, {
  value: 441400,
  text: '梅州市',
  parentId: 440000
}, {
  value: 441500,
  text: '汕尾市',
  parentId: 440000
}, {
  value: 441600,
  text: '河源市',
  parentId: 440000
}, {
  value: 441700,
  text: '阳江市',
  parentId: 440000
}, {
  value: 441800,
  text: '清远市',
  parentId: 440000
}, {
  value: 441900,
  text: '东莞市',
  parentId: 440000
}, {
  value: 442000,
  text: '中山市',
  parentId: 440000
}, {
  value: 445100,
  text: '潮州市',
  parentId: 440000
}, {
  value: 445200,
  text: '揭阳市',
  parentId: 440000
}, {
  value: 445300,
  text: '云浮市',
  parentId: 440000
}, {
  value: 450100,
  text: '南宁市',
  parentId: 450000
}, {
  value: 450200,
  text: '柳州市',
  parentId: 450000
}, {
  value: 450300,
  text: '桂林市',
  parentId: 450000
}, {
  value: 450400,
  text: '梧州市',
  parentId: 450000
}, {
  value: 450500,
  text: '北海市',
  parentId: 450000
}, {
  value: 450600,
  text: '防城港市',
  parentId: 450000
}, {
  value: 450700,
  text: '钦州市',
  parentId: 450000
}, {
  value: 450800,
  text: '贵港市',
  parentId: 450000
}, {
  value: 450900,
  text: '玉林市',
  parentId: 450000
}, {
  value: 451000,
  text: '百色市',
  parentId: 450000
}, {
  value: 451100,
  text: '贺州市',
  parentId: 450000
}, {
  value: 451200,
  text: '河池市',
  parentId: 450000
}, {
  value: 451300,
  text: '来宾市',
  parentId: 450000
}, {
  value: 451400,
  text: '崇左市',
  parentId: 450000
}, {
  value: 460100,
  text: '海口市',
  parentId: 460000
}, {
  value: 460200,
  text: '三亚市',
  parentId: 460000
}, {
  value: 460300,
  text: '三沙市',
  parentId: 460000
}, {
  value: 469000,
  text: '省直辖县级行政区划',
  parentId: 460000
}, {
  value: 500100,
  text: '渝中区',
  parentId: 500000
}, {
  value: 500200,
  text: '大渡口区',
  parentId: 500000
}, {
  value: 500300,
  text: '江北区',
  parentId: 500000
}, {
  value: 500400,
  text: '沙坪坝区',
  parentId: 500000
}, {
  value: 500500,
  text: '九龙坡区',
  parentId: 500000
}, {
  value: 500600,
  text: '南岸区',
  parentId: 500000
}, {
  value: 500700,
  text: '北碚区',
  parentId: 500000
}, {
  value: 500800,
  text: '渝北区',
  parentId: 500000
}, {
  value: 500900,
  text: '巴南区',
  parentId: 500000
}, {
  value: 501000,
  text: '万州区',
  parentId: 500000
}, {
  value: 501100,
  text: '涪陵区',
  parentId: 500000
}, {
  value: 501200,
  text: '黔江区',
  parentId: 500000
}, {
  value: 501300,
  text: '长寿区',
  parentId: 500000
}, {
  value: 501400,
  text: '江津区',
  parentId: 500000
}, {
  value: 501500,
  text: '合川区',
  parentId: 500000
}, {
  value: 501600,
  text: '永川区',
  parentId: 500000
}, {
  value: 501700,
  text: '南川区',
  parentId: 500000
}, {
  value: 501800,
  text: '綦江区',
  parentId: 500000
}, {
  value: 501900,
  text: '大足区',
  parentId: 500000
}, {
  value: 502000,
  text: '璧山区',
  parentId: 500000
}, {
  value: 502100,
  text: '铜梁区',
  parentId: 500000
}, {
  value: 502200,
  text: '潼南区',
  parentId: 500000
}, {
  value: 502300,
  text: '荣昌区',
  parentId: 500000
}, {
  value: 502400,
  text: '开州区',
  parentId: 500000
}, {
  value: 502500,
  text: '梁平区',
  parentId: 500000
}, {
  value: 502600,
  text: '武隆区',
  parentId: 500000
}, {
  value: 502700,
  text: '城口县',
  parentId: 500000
}, {
  value: 502800,
  text: '丰都县',
  parentId: 500000
}, {
  value: 502900,
  text: '垫江县',
  parentId: 500000
}, {
  value: 503000,
  text: '忠县',
  parentId: 500000
}, {
  value: 503100,
  text: '云阳县',
  parentId: 500000
}, {
  value: 503200,
  text: '奉节县',
  parentId: 500000
}, {
  value: 503300,
  text: '巫山县',
  parentId: 500000
}, {
  value: 503400,
  text: '巫溪县',
  parentId: 500000
}, {
  value: 503500,
  text: '石柱县',
  parentId: 500000
}, {
  value: 503600,
  text: '秀山县',
  parentId: 500000
}, {
  value: 503700,
  text: '酉阳县',
  parentId: 500000
}, {
  value: 503800,
  text: '彭水县',
  parentId: 500000
}, {
  value: 510100,
  text: '成都市',
  parentId: 510000
}, {
  value: 510300,
  text: '自贡市',
  parentId: 510000
}, {
  value: 510400,
  text: '攀枝花市',
  parentId: 510000
}, {
  value: 510500,
  text: '泸州市',
  parentId: 510000
}, {
  value: 510600,
  text: '德阳市',
  parentId: 510000
}, {
  value: 510700,
  text: '绵阳市',
  parentId: 510000
}, {
  value: 510800,
  text: '广元市',
  parentId: 510000
}, {
  value: 510900,
  text: '遂宁市',
  parentId: 510000
}, {
  value: 511000,
  text: '内江市',
  parentId: 510000
}, {
  value: 511100,
  text: '乐山市',
  parentId: 510000
}, {
  value: 511300,
  text: '南充市',
  parentId: 510000
}, {
  value: 511400,
  text: '眉山市',
  parentId: 510000
}, {
  value: 511500,
  text: '宜宾市',
  parentId: 510000
}, {
  value: 511600,
  text: '广安市',
  parentId: 510000
}, {
  value: 511700,
  text: '达州市',
  parentId: 510000
}, {
  value: 511800,
  text: '雅安市',
  parentId: 510000
}, {
  value: 511900,
  text: '巴中市',
  parentId: 510000
}, {
  value: 512000,
  text: '资阳市',
  parentId: 510000
}, {
  value: 513200,
  text: '阿坝藏族羌族自治州',
  parentId: 510000
}, {
  value: 513300,
  text: '甘孜藏族自治州',
  parentId: 510000
}, {
  value: 513400,
  text: '凉山彝族自治州',
  parentId: 510000
}, {
  value: 520100,
  text: '贵阳市',
  parentId: 520000
}, {
  value: 520200,
  text: '六盘水市',
  parentId: 520000
}, {
  value: 520300,
  text: '遵义市',
  parentId: 520000
}, {
  value: 520400,
  text: '安顺市',
  parentId: 520000
}, {
  value: 520500,
  text: '毕节市',
  parentId: 520000
}, {
  value: 520600,
  text: '铜仁市',
  parentId: 520000
}, {
  value: 522300,
  text: '黔西南布依族苗族自治州',
  parentId: 520000
}, {
  value: 522600,
  text: '黔东南苗族侗族自治州',
  parentId: 520000
}, {
  value: 522700,
  text: '黔南布依族苗族自治州',
  parentId: 520000
}, {
  value: 530100,
  text: '昆明市',
  parentId: 530000
}, {
  value: 530300,
  text: '曲靖市',
  parentId: 530000
}, {
  value: 530400,
  text: '玉溪市',
  parentId: 530000
}, {
  value: 530500,
  text: '保山市',
  parentId: 530000
}, {
  value: 530600,
  text: '昭通市',
  parentId: 530000
}, {
  value: 530700,
  text: '丽江市',
  parentId: 530000
}, {
  value: 530800,
  text: '普洱市',
  parentId: 530000
}, {
  value: 530900,
  text: '临沧市',
  parentId: 530000
}, {
  value: 532300,
  text: '楚雄彝族自治州',
  parentId: 530000
}, {
  value: 532500,
  text: '红河哈尼族彝族自治州',
  parentId: 530000
}, {
  value: 532600,
  text: '文山壮族苗族自治州',
  parentId: 530000
}, {
  value: 532800,
  text: '西双版纳傣族自治州',
  parentId: 530000
}, {
  value: 532900,
  text: '大理白族自治州',
  parentId: 530000
}, {
  value: 533100,
  text: '德宏傣族景颇族自治州',
  parentId: 530000
}, {
  value: 533300,
  text: '怒江傈僳族自治州',
  parentId: 530000
}, {
  value: 533400,
  text: '迪庆藏族自治州',
  parentId: 530000
}, {
  value: 540100,
  text: '拉萨市',
  parentId: 540000
}, {
  value: 540200,
  text: '日喀则市',
  parentId: 540000
}, {
  value: 542100,
  text: '昌都地区',
  parentId: 540000
}, {
  value: 542200,
  text: '山南地区',
  parentId: 540000
}, {
  value: 542400,
  text: '那曲地区',
  parentId: 540000
}, {
  value: 542500,
  text: '阿里地区',
  parentId: 540000
}, {
  value: 542600,
  text: '林芝地区',
  parentId: 540000
}, {
  value: 610100,
  text: '西安市',
  parentId: 610000
}, {
  value: 610200,
  text: '铜川市',
  parentId: 610000
}, {
  value: 610300,
  text: '宝鸡市',
  parentId: 610000
}, {
  value: 610400,
  text: '咸阳市',
  parentId: 610000
}, {
  value: 610500,
  text: '渭南市',
  parentId: 610000
}, {
  value: 610600,
  text: '延安市',
  parentId: 610000
}, {
  value: 610700,
  text: '汉中市',
  parentId: 610000
}, {
  value: 610800,
  text: '榆林市',
  parentId: 610000
}, {
  value: 610900,
  text: '安康市',
  parentId: 610000
}, {
  value: 611000,
  text: '商洛市',
  parentId: 610000
}, {
  value: 620100,
  text: '兰州市',
  parentId: 620000
}, {
  value: 620200,
  text: '嘉峪关市',
  parentId: 620000
}, {
  value: 620300,
  text: '金昌市',
  parentId: 620000
}, {
  value: 620400,
  text: '白银市',
  parentId: 620000
}, {
  value: 620500,
  text: '天水市',
  parentId: 620000
}, {
  value: 620600,
  text: '武威市',
  parentId: 620000
}, {
  value: 620700,
  text: '张掖市',
  parentId: 620000
}, {
  value: 620800,
  text: '平凉市',
  parentId: 620000
}, {
  value: 620900,
  text: '酒泉市',
  parentId: 620000
}, {
  value: 621000,
  text: '庆阳市',
  parentId: 620000
}, {
  value: 621100,
  text: '定西市',
  parentId: 620000
}, {
  value: 621200,
  text: '陇南市',
  parentId: 620000
}, {
  value: 622900,
  text: '临夏回族自治州',
  parentId: 620000
}, {
  value: 623000,
  text: '甘南藏族自治州',
  parentId: 620000
}, {
  value: 630100,
  text: '西宁市',
  parentId: 630000
}, {
  value: 630200,
  text: '海东市',
  parentId: 630000
}, {
  value: 632200,
  text: '海北藏族自治州',
  parentId: 630000
}, {
  value: 632300,
  text: '黄南藏族自治州',
  parentId: 630000
}, {
  value: 632500,
  text: '海南藏族自治州',
  parentId: 630000
}, {
  value: 632600,
  text: '果洛藏族自治州',
  parentId: 630000
}, {
  value: 632700,
  text: '玉树藏族自治州',
  parentId: 630000
}, {
  value: 632800,
  text: '海西蒙古族藏族自治州',
  parentId: 630000
}, {
  value: 640100,
  text: '银川市',
  parentId: 640000
}, {
  value: 640200,
  text: '石嘴山市',
  parentId: 640000
}, {
  value: 640300,
  text: '吴忠市',
  parentId: 640000
}, {
  value: 640400,
  text: '固原市',
  parentId: 640000
}, {
  value: 640500,
  text: '中卫市',
  parentId: 640000
}, {
  value: 650100,
  text: '乌鲁木齐市',
  parentId: 650000
}, {
  value: 650200,
  text: '克拉玛依市',
  parentId: 650000
}, {
  value: 652100,
  text: '吐鲁番地区',
  parentId: 650000
}, {
  value: 652200,
  text: '哈密地区',
  parentId: 650000
}, {
  value: 652300,
  text: '昌吉回族自治州',
  parentId: 650000
}, {
  value: 652700,
  text: '博尔塔拉蒙古自治州',
  parentId: 650000
}, {
  value: 652800,
  text: '巴音郭楞蒙古自治州',
  parentId: 650000
}, {
  value: 652900,
  text: '阿克苏地区',
  parentId: 650000
}, {
  value: 653000,
  text: '克孜勒苏柯尔克孜自治州',
  parentId: 650000
}, {
  value: 653100,
  text: '喀什地区',
  parentId: 650000
}, {
  value: 653200,
  text: '和田地区',
  parentId: 650000
}, {
  value: 654000,
  text: '伊犁哈萨克自治州',
  parentId: 650000
}, {
  value: 654200,
  text: '塔城地区',
  parentId: 650000
}, {
  value: 654300,
  text: '阿勒泰地区',
  parentId: 650000
}, {
  value: 659000,
  text: '自治区直辖县级行政区划',
  parentId: 650000
}, {
  value: 810100,
  text: '香港岛',
  parentId: 810000
}, {
  value: 810200,
  text: '九龙半岛',
  parentId: 810000
}, {
  value: 810300,
  text: '新界',
  parentId: 810000
}, {
  value: 820100,
  text: '澳门半岛',
  parentId: 820000
}, {
  value: 820200,
  text: '离岛',
  parentId: 820000
}, {
  value: 820300,
  text: '无堂区划分区域',
  parentId: 820000
}, {
  value: 710100,
  text: '台北市',
  parentId: 710000
}, {
  value: 710200,
  text: '髙雄市',
  parentId: 710000
}, {
  value: 710300,
  text: '基隆市',
  parentId: 710000
}, {
  value: 710400,
  text: '台中市',
  parentId: 710000
}, {
  value: 710500,
  text: '台南市',
  parentId: 710000
}, {
  value: 710600,
  text: '新竹市',
  parentId: 710000
}, {
  value: 710700,
  text: '嘉义市',
  parentId: 710000
}, {
  value: 710800,
  text: '新北市',
  parentId: 710000
}, {
  value: 710900,
  text: '宜兰县',
  parentId: 710000
}, {
  value: 711000,
  text: '桃园县',
  parentId: 710000
}, {
  value: 711100,
  text: '新竹县',
  parentId: 710000
}, {
  value: 711200,
  text: '苗栗县',
  parentId: 710000
}, {
  value: 711300,
  text: '彰化县',
  parentId: 710000
}, {
  value: 711400,
  text: '南投县',
  parentId: 710000
}, {
  value: 711500,
  text: '云林县',
  parentId: 710000
}, {
  value: 711600,
  text: '嘉义县',
  parentId: 710000
}, {
  value: 711700,
  text: '屏东县',
  parentId: 710000
}, {
  value: 711800,
  text: '台东县',
  parentId: 710000
}, {
  value: 711900,
  text: '花莲县',
  parentId: 710000
}, {
  value: 712000,
  text: '澎湖县',
  parentId: 710000
}];



// WEBPACK FOOTER //
// ./src/components/provinceCity/cityData.js